const designBio = {
    description: `Hi, I’m Karan ( k4ran909 ) I’m a designer and creative developer who loves blending art, design, and code to bring ideas to life. Based in [your city], I focus on crafting engaging websites and web experiences that combine clean structure with playful creativity.

    Coming from a mix of design and development, I’ve learned to always think about the audience first — how they feel, interact, and connect with what I create. I’m especially passionate about projects that let me experiment with UI effects, smooth animations, and dynamic storytelling through design.
    
    Here are a few technologies I've been working with recently:`,
    tools: [
        'Krita',
        'Adobe Illustrator',
        'Davinci Resolve',
        'Hitfilm Express',
        'Adobe After Effects',
        'Adobe Premier'],
    image: '/assets/images/about/designAvatar.png',
    webpImage: '/assets/images/about/designAvatar.webp',
    caption: 'When sushi enters the frame, Karan transforms into a living moodboard of joy, obsession, and aesthetic chaos.'
}

export default designBio;